import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import ModalShareArticle from '../../../../Modal/ModalShareArticle';
import "./SocialAction.scss";
import ModalSignIn from "../../../../Modal/ModalSignIn/ModalSignIn";

function SocialAction (props) {
  const { likes, style, statusSession, shared, link, shareButton, handleLike, handleShare, likeUsers, userId } = props;
  const [openModal, setOpenModal] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);

  useEffect(() => {
    statusSession && statusSession ===  2 && setOpenLogin(false);
  }, [statusSession]);

  const userLike = likeUsers && likeUsers.includes(userId);
  const numberLikes = (likes>0) ? likes : "";
  const srcImage = numberLikes && statusSession ===  2 && userLike ? "/img/social-actions/like-mint.svg" : "/img/social-actions/like-gray.svg";
  const handleClose = () => {
    setOpenModal(false);
  };


  const handleLikeClick = () => {
    statusSession && statusSession ===  2 ?  handleLike() : setOpenLogin(true) ;
  }
  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  
  return (
    <>
    <div className= "socialAction-container" style={style}>
      <div className= "socialAction-container-like" onClick={handleLikeClick}>
        <img className= "button-icon" src={srcImage} alt="icono like"></img>
        <div className={numberLikes && statusSession ===  2 && userLike ? "button-text active" : "button-text disabled"}>{`${numberLikes} Me gusta`}</div>
      </div>
      {shareButton && <div 
        className= "socialAction-container-share" 
        onClick={() => setOpenModal(true)}
      >
        <img className= "button-icon" src="/img/social-actions/shared.svg" alt="icono compartir"/>
        <div className="button-text disabled">{shared? shared:''} Compartir</div>
      </div>}
    </div>
    <ModalShareArticle
        open={openModal}
        handleClose={handleClose}
        link={link}
        handleSubmit = {handleShare}
      />
    <ModalSignIn open={openLogin} handleClose={handleCloseLogin} />
    </>
  );
}

const mapStateToProps = (state) => ({
  statusSession: state.userState.statusUser,
  userId: state.authClient.uid,
});

export default connect(mapStateToProps)(SocialAction) ;
